<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">CONTENTS</h1>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_int.htm"><strong>Introduction</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_equ.htm"><strong>Equipment</strong></a></p>
<p class="center"><img alt="" src="OEBPS/images/5-1.jpg"/></p>
<p class="extract"><a href="#/OEBPS/9781446352496_epub_c01.htm"><strong>CHAPTER 1: CONTROLLING EXPOSURE BY DARWIN WIGGETT</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c01.htm#a01"><strong>The RAW advantage</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c01.htm#a02"><strong>Aperture choice and the WO-M-EN concept</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c01.htm#a03"><strong>Using the histogram</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c01.htm#a04"><strong>Fixing a broken histogram</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c01.htm#a05"><strong>Post-production contrast control</strong></a></p>
<p class="center"><img alt="" src="OEBPS/images/5-2.jpg"/></p>
<p class="extract"><a href="#/OEBPS/9781446352496_epub_c02.htm"><strong>CHAPTER 2: UNDERSTANDING LIGHT BY DAVID NOTON</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c02.htm#a06"><strong>A feel for light</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c02.htm#a07"><strong>Time of day: from dawn to dusk</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c02.htm#a08"><strong>Colour temperature: use it or lose it</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c02.htm#a09"><strong>Colour quality: full-throttle or watercolour?</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c02.htm#a10"><strong>A sense of direction</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c02.htm#a11"><strong>Weather: dodging the rain clouds</strong></a></p>
<p class="center"><img alt="" src="OEBPS/images/5-3.jpg"/></p>
<p class="extract"><a href="#/OEBPS/9781446352496_epub_c03.htm"><strong>CHAPTER 3: COMPOSING LANDSCAPE IMAGES BY WILLIAM NEILL</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a12"><strong>Using the frame</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a13"><strong>Order out of chaos</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a14"><strong>Depth in the landscape</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a15"><strong>Cropping</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a16"><strong>Working the scene</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a17"><strong>Creating a panorama</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c03.htm#a18"><strong>Description vs. interpretation</strong></a></p>
<p class="center"><img alt="" src="OEBPS/images/5-4.jpg"/></p>
<p class="extract"><a href="#/OEBPS/9781446352496_epub_c04.htm"><strong>CHAPTER 4: LANDSCAPE LOCATIONS BY TOM MACKIE</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a19"><strong>Research and planning</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a20"><strong>Water in the landscape</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a21"><strong>Mountains</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a22"><strong>Deserts and wilderness</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a23"><strong>Forests and woodland</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a24"><strong>Urban landscapes</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a25"><strong>Exploring your local landscape</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c04.htm#a26"><strong>Changing the sky</strong></a></p>
<p class="center"><img alt="" src="OEBPS/images/5-5.jpg"/></p>
<p class="extract"><a href="#/OEBPS/9781446352496_epub_c05.htm"><strong>CHAPTER 5: LANDSCAPES IN BLACK AND WHITE BY TONY WOROBIEC</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a27"><strong>The black and white mindset</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a28"><strong>In-camera settings for black and white</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a29"><strong>Converting colour to monochrome</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a30"><strong>Non-destructive dodging and burning</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a31"><strong>Sepia toning</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a32"><strong>Blue toning using duotone</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a33"><strong>Dual toning using selective colour</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a34"><strong>Creating a lith effect</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_c05.htm#a35"><strong>Simulating hand-colouring digitally</strong></a></p>
<p class="extract"><a href="#/OEBPS/9781446352496_epub_ata.htm"><strong>Author biographies</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_ind.htm"><strong>Index</strong></a></p>
<p class="toc"><a href="#/OEBPS/9781446352496_epub_ack.htm"><strong>Acknowledgments</strong></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446352496_epub_toc.vue?4785f68a